import { useTranslation } from "react-i18next"
import System from "../Dev/System"
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material"

const SystemInfoDialog = ({handleClose, open}: {handleClose: () => void, open: boolean}) => {
  const { t } = useTranslation()

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogContent sx={{paddingTop: 0}}>
        <System />
      </DialogContent>
      <DialogActions sx={{margin: "10px"}}>
        <Button variant="contained" onClick={handleClose} autoFocus>{t('Ok')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default SystemInfoDialog
